import styled from "styled-components";

const Title = styled.h1<{ color?: string; }>`
  font-size: 1.5em;
  text-align: center;
  color: ${props => props.color};
`;

export default Title;
